
import Vue from 'vue';
import PageNotificationBar from '~/components/page-components/PageNotificationBar.vue'
import { isPwaInstallable, isPwaStore } from '~/lib/accessors/store-accessor';


export default Vue.extend({
  components: {PageNotificationBar},
  data() {
    return {
      banner_was_closed_by_user: this.$cookies.isKey('kip-app-banner-was-closed-by-user'),
    }
  },
  methods: {
    close(): void {
      this.banner_was_closed_by_user = true;
      this.$cookies.set('kip-app-banner-was-closed-by-user', 'skip', '14d')
    },
    async install() {
      const result = await this.install_prompt.prompt();
      console.log(`Install prompt was: ${result.outcome}`);
    }
  },
  computed: {
    show(): boolean {
      const is_within_pwa = isPwaStore.is_pwa;
      const install_prompt = this.install_prompt;
      const banner_was_closed_by_user = this.banner_was_closed_by_user;

      return ! is_within_pwa && ! banner_was_closed_by_user && install_prompt;
    },
    install_prompt(): any {
      return isPwaInstallable.install_prompt;
    }
  }
})
